import React from 'react';
import { observer } from "mobx-react-lite";
import { Layout } from "../modules/Layout";
import Components from "../modules/Component/Components/TableComponent";

export const ComponentPage = observer(() => {
    return (
        <Layout offset={{left: 1}}>
            <Components/>
        </Layout>
    )
});